// Third-party
import React from 'react';

// Components
import { HoldingIcon } from '../../common';

// Utils
import { enumerateArray, truncateString } from '../../../../utils/objects';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import { getShortHistoryDatesForItemWithTimeframe } from '../../../../utils/disclaimers/comparison';
import { formatLocalizedString, formatMessageWithLocale } from '../../../../utils/i18n';
import { COMPARISON_ITEM_TYPES } from '../../../../utils/constants';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import Nullable from '@/types/nullable';

type Props = {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
  disclaimerFieldFilter?: string;
  startDate?: Nullable<Date>;
  endDate?: Nullable<Date>;
};

const ShortHistoryPortfoliosDisclaimer = ({ items, showItemNames = true, locale, disclaimerFieldFilter, startDate, endDate }: Props) => {
  const shortItems = items.filter(item => {
    if (!([COMPARISON_ITEM_TYPES.BENCHMARK, COMPARISON_ITEM_TYPES.PORTFOLIO] as string[]).includes(item.type)) {
      return false;
    }

    return !!item.disclaimers && !!item.disclaimers[DISCLAIMER_KEYS.SHORT_HOLDINGS];
  });

  const getNameElement = (item: ComparisonItem) => {
    let label = truncateString(formatLocalizedString(item.name, locale), 40);

    if (item.type !== COMPARISON_ITEM_TYPES.PORTFOLIO && item.holdings[0].symbol) {
      label = item.holdings[0].symbol;
    }

    return (
      <span key={item._id} className="item-name" data-private data-dd-privacy="mask">
        <HoldingIcon color={item.color} type={item.type} />
        {label}
      </span>
    );
  };

  return (
    <>
      {shortItems.map((item, i) => {
        const disclaimersWithDate = getShortHistoryDatesForItemWithTimeframe(item, locale, disclaimerFieldFilter, startDate, endDate);

        if (disclaimersWithDate.length === 0) return null;

        return (
          <span className="disclaimer" key={item._id}>
            {i === 0 && '*'}

            <span key={item._id} data-private data-dd-privacy="mask">
              {showItemNames && <>{getNameElement(item)}</>}

              {!showItemNames && formatMessageWithLocale('Disclaimers.ThisField', locale)}

              {'\xa0'}
              {formatMessageWithLocale('Disclaimers.ItemDoesNotInclude', locale)}
              {enumerateArray(disclaimersWithDate, formatMessageWithLocale('Common.And', locale))}
              {'. '}
            </span>
          </span>
        );
      })}
    </>
  );
};

export default ShortHistoryPortfoliosDisclaimer;
